export const selectRemoteAccess = [
  {
    key: "enabled",
    value: true,
    label: "有効",
    stroke: "red",
  },
  {
    key: "disabled",
    value: false,
    label: "無効",
    stroke: "blue",
  },
];

export const selectEnableTime = [
  {
    key: "one",
    value: 1,
    label: "1時間",
  },
  {
    key: "three",
    value: 3,
    label: "3時間",
  },
  {
    key: "six",
    value: 6,
    label: "6時間",
  },
  {
    key: "twelve",
    value: 12,
    label: "12時間",
  },
];
